



































import { Component, Vue, Prop } from "vue-property-decorator";
import { ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../../Models/Buttons";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";


@Component({
	name: "ButtonList",
	components: { ParticaRowContainer }
})
export default class ButtonList extends Vue {
	@Prop() private buttons: ButtonConfig[]; // buttons 
	@Prop() private validform: boolean; // if set, then buttons are part of form, we can disable etc based on this.
	@Prop() private item: any;
	private clicked: boolean = false;

	private async buttonClicked(button: ButtonConfig, event: MouseEvent) {
		this.clicked = true;
		// check if passed in form validator is valid before allowing OK events.
		if (button.type === ButtonType.OK) {
			if (this.validform !== undefined) {
				if (this.validform === true) {
					this.$emit("partica-event", {
						action: button.action,
						sourceEvent: event
					} as ParticaEvent);
				}
			} else {
				// no form so pass up.
				this.$emit("partica-event", {
					action: button.action,
					sourceEvent: event
				} as ParticaEvent);
			}
		} else {
			this.$emit("partica-event", {
				action: button.action,
				sourceEvent: event,
				item: this.item
			} as ParticaEvent);
		}
		setTimeout(() => {
			this.clicked = false;
		}, 300);
	}
	private getColor(button: ButtonConfig): string {
		switch (button.type) {
			case ButtonType.Highlight: {
				return "green";
			}
			case ButtonType.OK: {
				return "primary";
			}
			case ButtonType.Cancel: {
				return "error";
			}
			case ButtonType.Normal: {
				return "";
			}
			default: {
				return "orange";
			}
		}
	}
	private getType(button: ButtonConfig): string {
		switch (button.type) {
			case ButtonType.OK: {
				return "submit";
			}
			case ButtonType.Cancel:
			case ButtonType.Normal:
			default: {
				return "";
			}
		}
	}
	private getDisabled(button: ButtonConfig): boolean {
		if (this.clicked === true) {
			return true;
		}
		switch (button.status) {
			case ButtonStatus.Disabled: {
				return true;
			}
			default: {
				if (button.type === ButtonType.OK) {
					if (this.validform === false) {
						return true;
					}
				}
				return false;
			}
		}
	}
}
